module.exports = __webpack_public_path__ + "img/project-2.7eef69ef.png";